import React from 'react'
import { Divider } from '@fs/zion-ui'

const BottomSheetDivider = () => {
  return <Divider marginY="nano" />
}
export default BottomSheetDivider
